module.exports = __webpack_public_path__ + "static/media/room-service.67cc65b8.svg";